module.exports = __webpack_public_path__ + "img/ron-tite.32cde29f.png";